module.exports = __webpack_public_path__ + "static/media/progger1.1b058c0e.png";